import React from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import './powerBiDashboard.scss';

export default function PowerBiDashboard() {
    return (
      <iframe
        title="Dashboard"
        src={process.env.REACT_APP_POWERBI_EMBED_URL}
        style={{ width: '100%', height: 'calc(100vh - 80px)', border: 0 }}
      />
    );
  }
  